export default "__VITE_ASSET__BkLpLyZW__"